import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showAppOverlay, hideAppOverlay } from 'store/shared/actions';
import ReactDOM from 'react-dom';
import { getIsUserSubscribed, getUser } from 'store/users/selectors';
import {
  Button, Icon, StyledClickOutside, ActionButton, Container, ActionsContainer, Info,
} from './styles';

export default ({ data = [], isShifted = false }) => {
  const dispatch = useDispatch();
  const [fade, setFade] = useState(false);
  const [isMenuOpened, setMenuOpened] = useState(false);
  const isUserSubscribed = useSelector(getIsUserSubscribed);
  const user = useSelector(getUser);

  const handleClick = () => {
    if (data.length === 1) {
      const [{ action }] = data;

      action();
    } else {
      if (!isMenuOpened) {
        dispatch(showAppOverlay());
      } else {
        dispatch(hideAppOverlay());
      }

      setMenuOpened(((prevState) => !prevState));

      setTimeout(() => {
        setFade(((prevState) => !prevState));
      }, 0);
    }
  };

  const handleExit = (event) => {
    event.stopPropagation();
    dispatch(hideAppOverlay());

    setFade(false);

    setTimeout(() => {
      setMenuOpened(false);
    }, 250);
  };

  const domNode = document.body;

  return (
    <>
      {
        isMenuOpened ? ReactDOM.createPortal(
          <StyledClickOutside
            onClickOutside={(event) => handleExit(event)}
            onClick={(event) => handleExit(event)}
            isShifted={isShifted}
          >
            <ActionsContainer style={{ opacity: fade ? 1 : 0 }}>
              {data.map(({
                id,
                icon,
                label,
                action,
                disabled = false,
              }) => (
                <ActionButton
                  key={id}
                  disabled={disabled || !isUserSubscribed}
                  onClick={(event) => {
                    handleExit(event);

                    action();
                  }}
                >
                  <Icon className={icon} />
                  <span>{label}</span>
                </ActionButton>
              ))}
            </ActionsContainer>
            <Button onClick={(event) => handleExit(event)}>
              <Icon className={isMenuOpened ? 'icon-close-1' : 'icon-plus-big'} />
            </Button>
          </StyledClickOutside>, domNode,
        ) : (
          <Container isShifted={isShifted} style={{ opacity: fade ? 0 : 1 }}>
            {
              !isUserSubscribed && user ? (
                <Info>
                  Please subscribe to the app on your mobile device in order to add content.
                </Info>
              ) : null
            }
            <Button onClick={handleClick} isLoading={!user} disabled={!isUserSubscribed}>
              {
                (!isUserSubscribed) ? (
                  <Icon className={user ? 'icon-lock' : 'icon-loader'} />
                ) : (
                  <Icon className={isMenuOpened ? 'icon-close-1' : 'icon-plus-big'} />
                )
              }
            </Button>
          </Container>
        )
      }
    </>
  );
};
